// EditScriptProfileModal.jsx
import React, { useState, useEffect } from 'react';
import { Save, X } from 'lucide-react';
import { router } from '@inertiajs/react';

const EditScriptProfileModal = ({ isOpen, onClose, script, updateUrl }) => {
  const [formData, setFormData] = useState({
    disclosure_level: 'partial',
    is_featured: false,
    featured_note: '',
    logline: '',
    custom_usp: '',
    genres: [],
  });
const [loglineOptions, setLoglineOptions] = useState([]);

useEffect(() => {
  if (script && isOpen) {
    setLoglineOptions(script.loglines || []);  // <-- NEW
    setFormData({
      disclosure_level: script.profile_settings?.disclosure_level || 'partial',
      /* … unchanged … */
      logline: script.profile_settings?.logline || script.loglines?.[0] || '',
      /* … */
    });
  }
}, [script, isOpen]);


  useEffect(() => {
    if (script && isOpen) {
      setFormData({
        disclosure_level: script.profile_settings?.disclosure_level || 'partial',
        is_featured: script.profile_settings?.is_featured || false,
        featured_note: script.profile_settings?.featured_note || '',
        logline: script.profile_settings?.logline || script.logline || '',
        custom_usp: script.profile_settings?.custom_usp || script.usp || '',
        genres: script.profile_settings?.genres || script.genres || [],
      });
    }
  }, [script, isOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async () => {
    await fetch(`${updateUrl}${script.hash}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      },
      body: JSON.stringify({
        ...formData,
        is_public: true,
        allow_comments: true,
        allow_ratings: true,
        allow_connection_requests: true,
      }),
    });

    onClose();
    router.reload();
  };

  if (!isOpen || !script) return null;

  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Script Profile: {script.title}</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body">
{/* Logline picker */}
{loglineOptions.length > 0 && (
  <div className="mb-2">
    <label className="form-label small">Select existing logline</label>
    <select
      className="form-select form-select-sm"
      defaultValue=""
      onChange={(e) => {
        if (e.target.value) {
          setFormData({ ...formData, logline: e.target.value });
        }
      }}
    >
      <option value="" disabled>— choose —</option>
      {loglineOptions.map((ll, idx) => (
        <option key={idx} value={ll}>
          {ll.length > 80 ? ll.slice(0, 77) + '…' : ll}
        </option>
      ))}
    </select>
  </div>
)}

{/* Editable logline textarea remains exactly as before */}
<div className="mb-3">
  <label className="form-label">Logline</label>
  <textarea
    className="form-control"
    name="logline"
    rows="2"
    value={formData.logline}
    onChange={handleChange}
  ></textarea>
</div>

<div className="mb-3">
  <label className="form-label">Genres</label>
  <div className="form-control p-2" style={{ minHeight: '44px' }}>
    {formData.genres.map((genre, index) => (
      <span
        key={index}
        className="badge bg-primary me-1 mb-1"
        style={{ fontSize: '0.85rem' }}
      >
        {genre}
        <button
          type="button"
          className="btn-close btn-close-white btn-sm ms-1"
          onClick={() => {
            const updated = formData.genres.filter((_, i) => i !== index);
            setFormData({ ...formData, genres: updated });
          }}
          style={{ fontSize: '0.6em', verticalAlign: 'middle' }}
        ></button>
      </span>
    ))}
    <input
      type="text"
      className="border-0 ms-1"
      placeholder="Add genre..."
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ',') && e.target.value.trim()) {
          e.preventDefault();
          const newGenre = e.target.value.trim();
          if (!formData.genres.includes(newGenre)) {
            setFormData({ ...formData, genres: [...formData.genres, newGenre] });
          }
          e.target.value = '';
        }
      }}
      style={{ outline: 'none', minWidth: '100px' }}
    />
  </div>
  <div className="form-text">Press Enter or comma to add a genre.</div>
</div>
            {/* <div className="mb-3">
              <label className="form-label">Unique Selling Point</label>
              <textarea
                className="form-control"
                name="custom_usp"
                rows="4"
                value={formData.custom_usp}
                onChange={handleChange}
              ></textarea>
            </div> */}
            <div className="mb-3">
              <label className="form-label">Disclosure Level</label>
              <select
                className="form-select"
                name="disclosure_level"
                value={formData.disclosure_level}
                onChange={handleChange}
              >
                <option value="partial">Overview only</option>
                <option value="full">Full script and analysis</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Featured Note</label>
  <textarea
                className="form-control"
                name="featured_note"
                value={formData.featured_note}
                onChange={handleChange}
    rows="2"
  ></textarea>
            </div>
            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                name="is_featured"
                checked={formData.is_featured}
                onChange={handleChange}
                id="isFeaturedCheckbox"
              />
              <label className="form-check-label" htmlFor="isFeaturedCheckbox">
                Featured Script
              </label>
            </div>
          </div>
          <div className="modal-footer d-flex justify-content-between">
            <button className="btn btn-secondary" onClick={onClose}>
              <X size={18} className="me-1" /> Cancel
            </button>
            <button className="btn btn-primary" onClick={handleSubmit}>
              <Save size={18} className="me-1" /> Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditScriptProfileModal;
